const imagesModules = import.meta.glob('../assets/images/**/*', { eager: true });
let comps:any = {}; 
for (const path in imagesModules) {
	let str = "images/";
	let lastIndex = path.lastIndexOf(str);
	let cname = path.substring(lastIndex+(str?str.length:0));
	let pathName = imagesModules[path].default
	comps[cname] = pathName;
}

export const getLocalhostImage = (path: string) =>{
	return comps[path];
}